import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/auth/accept-invitation/page.tsx")